@if (emailConnected === null) {
  <div class="d-flex justify-content-center align-items-center" style="padding: 48px 0;">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
} @else if (emailConnected === false || showConnectForCreate) {
  <app-email-campaign-connect (connected)="onEmailConnected()"></app-email-campaign-connect>
} @else {
<div class="campaign-header-block">
<div class="toolbarHeading d-flex justify-content-between align-items-center rounded-lg">
  <div class="d-flex">

    <div class="mr-3">
      <div>
        <label for="search" class="search"> Search</label>
      </div>
      <app-custom-input
        placeholder="Search for email campaigns"
        (valueChange)="filterCampaign($event, 'input')"
        class="w-auto">
      </app-custom-input>
      <!-- <input data-testid="auto-app-email-campaign-create-campaign-input-1" type="text" name = 'search' (input)="filterCampaign($event.target.value, 'input')" placeholder="Search for email campaigns" class="srch"> -->
    </div>
    <div>
      <div>

        <label for="status" class="search">status</label>
      </div>
      <app-custom-dropdown
        placeholder="Select status"
        (selectionChange)="filterCampaign($event.value, 'select')">
        <app-dropdown-option [value]="0" [label]="'All'"></app-dropdown-option>
        <app-dropdown-option [value]="1" [label]="'Active'"></app-dropdown-option>
        <app-dropdown-option [value]="2" [label]="'Paused'"></app-dropdown-option>
        <app-dropdown-option [value]="3" [label]="'Draft'"></app-dropdown-option>
        <app-dropdown-option [value]="4" [label]="'Completed'"></app-dropdown-option>
      </app-custom-dropdown>
      <!-- <select data-testid="auto-app-email-campaign-create-campaign-select-1" name="" class="email-dropdown stats mx-1 py-1 w-auto pr-6" id="statusDropdown" (change)="filterCampaign($event.target.value, 'select')">
        <option value="0" >All</option>
        <option value="1">Active</option>
        <option value="2">Paused</option>
        <option value="3">Draft</option>
        <option value="4">Completed</option>
      </select> -->
    </div>
    <div *ngIf="!projectNumber" class="ml-3">
      <div>
        <label for="scope" class="search">Scope</label>
      </div>
      <app-custom-dropdown
        placeholder="All campaigns"
        (selectionChange)="onScopeFilterChange($event.value)">
        <app-dropdown-option [value]="'all'" [label]="'All'"></app-dropdown-option>
        <app-dropdown-option [value]="'global'" [label]="'Global'"></app-dropdown-option>
        <app-dropdown-option *ngFor="let project of projectOptions" [value]="project.projectid" [label]="project.projectname"></app-dropdown-option>
      </app-custom-dropdown>
    </div>
  </div>
  <div>
    <!-- <button data-testid="auto-app-email-campaign-create-campaign-button-1" class="bg-blue py-1 f-12 talent-btn text-white pointer text-center create-btn" class="btn" (click)="createCampaign()">+ New campaign</button> -->
  <button data-testid="auto-app-email-campaign-create-campaign-button-2" class="btn-trms-medium" (click)="createCampaign()"><i class="far fa-add mr-2"></i>New campaign</button>
  </div>

</div>

<div class="trms-info-panel text-black campaign-info-bar f-13" role="alert">
  <i class="fas fa-info-circle mr-2"></i>
  Only one campaign may be Active at a time per project (and one Global campaign). Pause the Active campaign in that scope before activating another.
</div>
</div>
<div class="table-container" style="height:80%">
 <!-- custom-table.component.html -->
<!-- <table class="custom-table">
  Add your table content here using the displayedColumns array -->
  <!-- <thead>
    <tr>
      <th *ngFor="let col of displayedColumns">{{ col }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let campaign of displayCampaigns">
      <td *ngFor="let col of displayedColumns">{{ campaign[col] }}</td>
    </tr>
  </tbody>
</table> -->
<table mat-table class="w-100 text-center email-campaign"  [dataSource]="campaigns" *ngIf="campaigns && campaigns.length">

  <!-- name -->
  <ng-container matColumnDef="campaign_name">
      <th mat-header-cell mat-header-cell *matHeaderCellDef  class="text-start">
            <p class="text-9696 f-12 m-0" style=" padding-left: 1rem;">Campaign Name</p>
      </th>
      <td class=" text-484b59 text-left " mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
        <div class="m-0" style="cursor: pointer; padding-left: 1rem;" (click)="redirectToListing(element)">
          <span class="font-weight-500 mb-1 text-webbtree-green d-block">
            {{element?.campaign_name }}
          </span>
          <div style="font-size: 12px">
            <span class="mr-1">{{ element?.created_on | date: 'dd MMM yyyy' }}</span> | <span class="ml-1" style="color: #969696;">{{element?.user?.firstname}} {{element?.user?.lastname }}</span>
            <ng-container *ngIf="!projectNumber">
              | <span class="ml-1" style="color: #969696;">{{ element?.project_id ? element?.project_name : 'Global' }}</span>
            </ng-container>
          </div>
        </div>
      </td>
  </ng-container>

   <!-- Recipients -->
   <ng-container matColumnDef="recipients">
      <th class="text-left" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by doc count" >
          <p class="text-9696 f-12 m-0"> Total Candidates</p>
      </th>
      <td class="text-left text-484b59" mat-cell *matCellDef="let element">
          {{element?.stats?.recipient | number}}
      </td>
  </ng-container>

  <!-- recentGraduate -->
  <ng-container matColumnDef="contact_available">
      <th class="text-left" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by doc count" >
          <p class="text-9696 f-12 m-0">Contact Available</p>
      </th>
      <td class="text-left text-484b59" mat-cell *matCellDef="let element">
            <!-- <p class="font-weight-600"> -->
              {{element?.stats?.contacts?.available | number}}
            <!-- </p> -->
      </td>
  </ng-container>
<ng-container matColumnDef="opened">
  <th class="text-left" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by doc count" >
      <p class="text-9696 f-12 m-0">Opened</p>
  </th>
  <td class="text-left text-484b59" mat-cell *matCellDef="let element">
        <!-- <p class="font-weight-600"> -->
          {{element?.stats?.opened || 0 | number : '1.0-2'}} %
        <!-- </p> -->
  </td>
</ng-container>
<ng-container matColumnDef="replied">
  <th class="text-left" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by doc count" >
      <p class="text-9696 f-12 m-0">Replied</p>
  </th>
  <td class="text-left text-484b59" mat-cell *matCellDef="let element">
        <!-- <p class="font-weight-600"> -->
          {{element?.stats?.replied || 0 | number : '1.0-2'}} %
        <!-- </p> -->
  </td>
</ng-container>
<!-- <ng-container matColumnDef="bounced">
  <th class="text-center" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by doc count" >
      <p class="text-9696 f-12 m-0">Bounced</p>
  </th>
  <td class=" text-484b59 font-weight-600" mat-cell *matCellDef="let element" class=""> -->
        <!-- <p class="font-weight-600"> -->
          <!-- {{element?.stats?.bounced || 0}} -->
        <!-- </p> -->
  <!-- </td>
</ng-container> -->
<!-- <ng-container matColumnDef="created_by">
  <th class="text-center" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by doc count" >
      <p class="text-9696 f-12 m-0">Created by</p>
  </th>
  <td class=" text-484b59 font-weight-600" mat-cell *matCellDef="let element" class="">
        <p class="font-weight-600">
          {{element?.created_by }}
        </p>
  </td>
</ng-container> -->
<!-- <ng-container matColumnDef="created_on">
  <th class="text-center" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by doc count" >
      <p class="text-9696 f-12 m-0">Date</p>
  </th>
  <td class=" text-484b59 font-weight-600" mat-cell *matCellDef="let element" class="">
        <p class="font-weight-600">
          {{element?.created_on | date: 'dd MMM yyyy'}}
        </p>
  </td>
</ng-container> -->
<!-- <ng-container matColumnDef="status">
  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by doc count" >
      <p class="text-9696 f-12 m-2">Status</p>
  </th>
  <td class=" text-484b59" mat-cell *matCellDef="let element">
    <div class="d-flex align-items-center" style="gap: 6px;">
      <select data-testid="auto-app-email-campaign-create-campaign-select-2" class="select-cand" style="width: max-content;" (change)="changeStatus($event, element)" [value]="element.status" [disabled]="element.status==4 || element.status==5 || element.status==3">
        <option *ngFor="let status of statuses" [value]="status.value" [hidden]="status.value==4 || status.value==5 || status.value==3">{{status.status}}</option>
      </select>
      <span *ngIf="element.status === 1 && element?.stats?.pending_limit <= 0" class="shield-pulse-wrapper" matTooltip="Protection mode is enabled. Emails will continue sending automatically within safe limits." matTooltipPosition="right">
        <span class="shield-pulse-ring"></span>
        <i class="fas fa-shield-check shield-pulse-icon pointer"></i>
      </span>
      <span *ngIf="isCampaignRecoverable(element.status, element.last_integration_error)" class="shield-pulse-wrapper" matTooltip="This campaign has encountered an error while sending emails. Please check sent email intimation for details to take necessary actions." matTooltipPosition="right">
        <i class="fa fa-question-circle-o pointer shield-pulse-icon text-9696"></i>
      </span>
    </div>
  </td>
</ng-container> -->


<ng-container matColumnDef="status">
  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by status">
    <p class="text-9696 f-12 m-2">Status</p>
  </th>

  <td class="text-484b59" mat-cell *matCellDef="let element">
    <div class="d-flex align-items-center" style="gap: 6px;">
      <select data-testid="auto-app-email-campaign-create-campaign-select-3" class="select-cand"
        [ngClass]="{ 'status-active': element.status == 1, 'status-paused': element.status == 2, 'status-draft': element.status == 3,'status-completed': element.status == 4,'status-error': element.status == 5}"
        [(ngModel)]="element.status" (ngModelChange)="changeStatus($event, element)"
        [disabled]="!element.permissions?.canChangeStatus || element.status == 4 || element.status == 5 || element.status == 3">

        <option *ngFor="let status of statuses" [ngValue]="status.value"
          [hidden]="status.value == 4 || status.value == 5 || status.value == 3">
          {{ status.status }}
        </option>
      </select>

      <!-- Protection mode -->
      <span *ngIf="element.status === 1 && element?.stats?.pending_limit <= 0" class="shield-pulse-wrapper"
        matTooltip="Protection mode is enabled. Emails will continue sending automatically within safe limits."
        matTooltipPosition="right">
        <span class="shield-pulse-ring"></span>
        <i class="fas fa-shield-check shield-pulse-icon pointer"></i>
      </span>

      <!-- Recoverable error -->
      <span *ngIf="isCampaignRecoverable(element.status, element.last_integration_error)" class="shield-pulse-wrapper"
        matTooltip="This campaign has encountered an error while sending emails. Please check sent email intimation for details to take necessary actions."
        matTooltipPosition="right">
        <i class="fa fa-question-circle-o pointer shield-pulse-icon text-9696"></i>
      </span>
    </div>
  </td>
</ng-container>

<ng-container matColumnDef="actions">
  <th mat-header-cell *matHeaderCellDef></th>
  <td mat-cell *matCellDef="let element">
    <div class="d-flex justify-content-end">
      <div ngbDropdown container="body">
        <button data-testid="auto-app-email-campaign-create-campaign-button-3" *ngIf="element.permissions?.canEdit" type="button" class="email-campaign-action-btn" ngbDropdownToggle>
          <i class="fas fa-ellipsis-vertical"></i>
        </button>
        <div ngbDropdownMenu *ngIf="element.permissions?.canEdit">
          <button data-testid="auto-app-email-campaign-create-campaign-button-4" ngbDropdownItem type="button" class="dropdown-item pointer f-12" (click)="openRenameModal(element)">
            <i class="far fa-edit me-2"></i>
            Rename
          </button>
        </div>
      </div>
    </div>
  </td>
</ng-container>


  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<div *ngIf="campaigns && !campaigns.length && isCampaignsCalled" class="emptyScreen">
  <div class="no-result-found">
    <img src="../../../assets/emptystate.png" style="width: 99px; height: 126px; margin-top: 3%;" alt="">
    <div class="font-weight-600">Result Not Found!</div>
  </div>
</div>

<div class="d-flex justify-content-center wccard ng-star-inserted email-campaign-pagination" *ngIf="totalCount > 10">
  <ngb-pagination [collectionSize]="totalCount" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize" rotate="false" (pageChange)="onPageChange($event)" [(page)]="currentPage" [ellipses]="false">
    <ng-template ngbPaginationPrevious> Previous </ng-template>
    <ng-template ngbPaginationNext> Next </ng-template>
  </ngb-pagination>
</div>

</div>

<ng-template #renameCampaignModal>
  <div class="modal-body">
    <div class="mb-3">
      <div class="header d-flex align-items-center" style="justify-content: space-between;">
        <div>
          <i class="fa-regular fa-pen-to-square mr-1" style="color: #2e93a1;"></i>
          <span class="modal-heading">Rename campaign</span>
        </div>
        <div>
          <span (click)="modalService.dismissAll()" style="cursor: pointer; color: #2c2c2c;">
            <i class="fa-regular fa-xmark"></i>
          </span>
        </div>
      </div>
    </div>
    <div>
      <form #renameForm="ngForm" (ngSubmit)="confirmRename()" novalidate>
        <label for="newCampaignName" class="mb-0">Campaign name</label>
        <input data-testid="auto-app-email-campaign-create-campaign-input-2"
          id="newCampaignName"
          name="newCampaignName"
          placeholder="Campaign name"
          [(ngModel)]="newCampaignName"
          class="campaign-inpt w-100"
          minlength="4"
          required
        />
        <div *ngIf="renameForm.controls['newCampaignName']?.errors?.required && renameForm.controls['newCampaignName']?.touched" class="error-message">
          Campaign name is required.
        </div>
        <div *ngIf="renameForm.controls['newCampaignName']?.errors?.minlength && renameForm.controls['newCampaignName']?.touched" class="error-message">
          Campaign name should be at least 4 characters long.
        </div>
      </form>
    </div>
    <button data-testid="auto-app-email-campaign-create-campaign-button-5" class="btn-trms-small d-block ml-auto mt-3" (click)="confirmRename()">Save</button>
  </div>
</ng-template>
}

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
